import React, { Component, Fragment } from 'react';
import { Flex, Carousel } from 'antd-mobile';
import '../ShopHomeLess.less';
import { PriceText, CardOpenTip } from 'widget';
import _ from 'lodash';
import { ImgWrap } from 'pubBiz';
import Util from 'utils';
import { observer, inject } from 'mobx-react';
import cx from 'classnames';

@inject('AppMod')
export default class Classify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHide: Util.getLocalCache('sourceXversePopup') == 'xverse'
    };
    this.appStore = this.props.AppMod;
  }

  onXverse = () => {
    const { userInfo, token } = this.appStore;
    // 元宇宙
    if (!token || !userInfo) {
      window.app.routerGoTo('/login?sourceType=xverse');
      return;
    }
    this.setState({
      isHide: false
    });
    this.appStore.jumpVerse(true);
  };

  render() {
    if (!this.state.isHide) return null;
    return (
      <div
        className={cx({
          'float-window': this.state.isHide
          // 'float-window-hide': !this.state.isHide,
        })}
        style={{
          bottom: '500px'
        }}
        onClick={() => {
          //各个功能点击次数统计埋点
          window.sensors.track('functionClickCount', {
            authCode: '', //权限点名称
            name: '元宇宙', //功能名字
            belongSystem: this.props.AppMod.userInfo && this.props.AppMod.userInfo.belongSystem, //站点
            position: '首页', //位置
            source: 'H5' //来源
          });
          this.onXverse();
        }}>
        <ImgWrap src={'https://image.yofogo.com/xverse_popup.png'} mode="full" w="100%" h="100%" />
        <div
          className="close-btn"
          onClick={(e) => {
            e.stopPropagation();
            localStorage.removeItem('sourceXversePopup');
            this.setState({
              isHide: false
            });
          }}>
          <span className="iconfont icon-close" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/XversePopup.js